import { client } from '../../interfaces'
import deleteFunction from '../crudFunctions/deleteFunction'

interface deleteClientModalProps {
  singleClient: client | null
  setShowDeleteClientModal: React.Dispatch<React.SetStateAction<boolean>>
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>
  trigger: boolean
}
const DeleteClientModal = ({
  singleClient,
  setShowDeleteClientModal,
  setTrigger,
  trigger
}: deleteClientModalProps) => {
  const deleteClient = (phone: string): void => {
    const endpoint: string = `client/${phone}/delete`
    deleteFunction(endpoint).then(() => setTrigger(!trigger))
  }
  return (
    <>
      <div id='deleteClientModal' className='modal'>
        <div className='modal-content justify-items-center rounded-md'>
          <h3 className='text-center text-2xl mb-5'>
            ¿Seguro que quieres eliminar este cliente?
          </h3>
          <h3 className='text-center text-2xl mb-5'>{singleClient?.name}</h3>
          <h4 className='mb-3 text-center'>
            Advertencia: Todos los pagos que tenga este cliente serán eliminados
          </h4>
          <div className='grid grid-cols-2 justify-items-center'>
            <button
              className='bg-green-400  text-white text-xl rounded-lg px-8 py-2 shadow-lg w-2/3'
              onClick={() => {
                deleteClient(singleClient!.phone)
                setShowDeleteClientModal(false)
                setTimeout(() => setTrigger(!trigger), 1000)
              }}>
              <span>Si</span>
            </button>
            <button
              className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 shadow-lg w-2/3'
              onClick={() => {
                setShowDeleteClientModal(false)
              }}>
              <span>No</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default DeleteClientModal
